import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, Input, HostBinding, NgModule } from '@angular/core';

class SeFeProgressBarComponent {
    constructor(el) {
        this.el = el;
        this.ticks = [];
        this.percentage = '';
        this.completed = 0;
        this.total = 100;
        this.active = false;
        this.segmented = false;
        this.success = false; // Deprecated
        this.baseClass = true;
        this.role = 'progressbar';
        //noop
    }
    get segmentedClass() { return this.segmented; }
    get defaultClass() { return !this.segmented; }
    get valueNow() {
        return this.completed;
    }
    get valueMax() {
        return this.total;
    }
    ngOnInit() {
        this.requiredAriaLabel();
    }
    ngOnChanges() {
        this.percentage = `${this.completed / this.total * 100}%`;
        if (this.segmented)
            this.setTicks();
    }
    setTicks() {
        this.ticks = [];
        if (this.total > 0) {
            let step = this.total;
            while (step -= 1)
                this.ticks.push('');
        }
    }
    requiredAriaLabel() {
        if (!this.element.getAttribute('aria-label') && !this.element.getAttribute('aria-labelledby')) {
            console.warn('Please add an aria-label or aria-labelledby to the progress bar');
        }
    }
    get element() {
        return this.el.nativeElement;
    }
}
SeFeProgressBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeProgressBarComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
SeFeProgressBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeProgressBarComponent, selector: "se-fe-progress-bar", inputs: { completed: ["seFeDataCompleted", "completed"], total: ["seFeDataTotal", "total"], active: ["seFeDataActive", "active"], segmented: ["seFeDataSegmented", "segmented"], success: ["seFeDataSuccess", "success"] }, host: { properties: { "class.se-fe-progress-bar": "this.baseClass", "class.se-fe-progress-bar--segmented": "this.segmentedClass", "class.se-fe-progress-bar--default": "this.defaultClass", "attr.role": "this.role", "attr.aria-valuenow": "this.valueNow", "attr.aria-valuemax": "this.valueMax" } }, usesOnChanges: true, ngImport: i0, template: "<div class=\"se-fe-progress-bar__ticks\" *ngIf=\"ticks.length\">\n  <span *ngFor=\"let tick of ticks\" class=\"se-fe-progress-bar__tick\"></span>\n</div>\n<div class=\"se-fe-progress-bar__progress\" [style.width]=\"percentage\"></div>\n<div *ngIf=\"active\" class=\"se-fe-progress-bar__highlight\" [style.width]=\"percentage\"></div>  \n", styles: ["@keyframes progress-bar{0%{background-position:0 50%}to{background-position:2000px 50%}}:host{--se-bg: var(--se-track);box-sizing:border-box;display:block;height:8px;position:relative}:host .se-fe-progress-bar__progress,:host .se-fe-progress-bar__highlight{box-sizing:content-box;height:100%;width:0%}:host .se-fe-progress-bar__highlight{animation:progress-bar 3s linear infinite;background-image:linear-gradient(to right,rgba(255,255,255,0) 0%,rgba(255,255,255,.5) 10%,rgba(0,0,0,.2) 11%,rgba(255,255,255,0) 45%,rgba(255,255,255,.5) 60%,rgba(0,0,0,.2) 61%,rgba(255,255,255,.5) 75%,rgba(255,255,255,0) 76%,rgba(0,0,0,.2) 90%,rgba(255,255,255,0) 100%);background-size:2000px;margin-top:-8px}:host.se-fe-progress-bar{background:var(--se-bg);padding-left:var(--se-content-spacing)}:host.se-fe-progress-bar .se-fe-progress-bar__progress,:host.se-fe-progress-bar .se-fe-progress-bar__highlight{margin-left:calc(0px - var(--se-content-spacing));padding-left:var(--se-content-spacing);transition:width .5s ease-out}:host.se-fe-progress-bar .se-fe-progress-bar__progress{background-image:linear-gradient(to right,color-mix(in srgb,var(--se-accent),var(--se-lighten-mix) 15%) 50%,color-mix(in srgb,var(--se-accent),var(--se-darken-mix) 48%))}:host.se-fe-progress-bar--segmented{background:var(--se-bg);padding-left:0}:host.se-fe-progress-bar--segmented .se-fe-progress-bar__progress{background-image:linear-gradient(to right,color-mix(in srgb,var(--se-accent),var(--se-lighten-mix) 15%) 50%,color-mix(in srgb,var(--se-accent),var(--se-darken-mix) 48%));margin-left:0;padding-left:0}:host .se-fe-progress-bar__ticks{justify-content:space-evenly;height:100%;display:flex;position:absolute;width:100%}:host .se-fe-progress-bar__ticks span{display:block;height:100%;width:2px;background:var(--se-accent-content)}\n"], directives: [{ type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeProgressBarComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-progress-bar',
                    templateUrl: './se-fe-progress-bar.component.html',
                    styleUrls: ['./se-fe-progress-bar.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { completed: [{
                type: Input,
                args: ['seFeDataCompleted']
            }], total: [{
                type: Input,
                args: ['seFeDataTotal']
            }], active: [{
                type: Input,
                args: ['seFeDataActive']
            }], segmented: [{
                type: Input,
                args: ['seFeDataSegmented']
            }], success: [{
                type: Input,
                args: ['seFeDataSuccess']
            }], baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-progress-bar']
            }], segmentedClass: [{
                type: HostBinding,
                args: ['class.se-fe-progress-bar--segmented']
            }], defaultClass: [{
                type: HostBinding,
                args: ['class.se-fe-progress-bar--default']
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }], valueNow: [{
                type: HostBinding,
                args: ['attr.aria-valuenow']
            }], valueMax: [{
                type: HostBinding,
                args: ['attr.aria-valuemax']
            }] } });

class SeFeProgressBarModule {
}
SeFeProgressBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeProgressBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeProgressBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeProgressBarModule, declarations: [SeFeProgressBarComponent], imports: [CommonModule], exports: [SeFeProgressBarComponent] });
SeFeProgressBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeProgressBarModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeProgressBarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFeProgressBarComponent],
                    imports: [CommonModule],
                    exports: [SeFeProgressBarComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeProgressBarComponent, SeFeProgressBarModule };
